export default "__VITE_ASSET__C6Rri9aW__"